import { useQuery } from '@apollo/client'
import React, { useEffect, useRef, useState } from 'react'
import { GET_ALL_USERS_QUALIFIED } from '../../../../../../graphql/Catalog/UsersRating/usersRating'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../../../Global/LayoutTable'
import ModalContent from '../../../../../Global/ModalContent'
import Ratings from './Ratings'
import DetailsRatings from './DetailsRatings'
import FormUsersRatings from '../../../UsersRatings/Components/FormUsersRatings'

const RatingsCoordinator = () => {
  const modalRef = useRef(null)
  const modalRefAux = useRef(null)
  const [dataTable, setDataTable] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [closeModal, setCloseModal] = useState(false)
  const [closeModalAux, setCloseModalAux] = useState(false)
  const [refetchs, setRefetchs] = useState([])
  const [pagePagination, setPagePagination] = useState({
    searchQuery: '',
    limit: 10,
    offset: 0,
  })
  const [modal, setModal] = useState({
    title: '',
    size: 'large',
    modalId: null,
    content: null,
  })
  const [modalAux, setModalAux] = useState({
    title: '',
    size: 'large',
    modalId: null,
    content: null,
  })

  const {
    loading: loadingUsersQualified,
    error: errorUsersQualified,
    data: dataUsersQualified,
    refetch,
  } = useQuery(GET_ALL_USERS_QUALIFIED, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    try {
      if (loadingUsersQualified) return
      if (errorUsersQualified) throw new Error(errorUsersQualified.message)
      const usersQualifiedData = dataUsersQualified.getAllUsersRated
      const ratingsData = usersQualifiedData.rows.map((item) => {
        return {
          id: item.id,
          nombre: `${item.name}`,
          cargo: item.JobPositionOfUser.name,
          rol: item.RoleOfUser.role_name,
          row__omit: item,
        }
      })

      setDataTable(ratingsData)
      setTotalCount(usersQualifiedData.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingUsersQualified, errorUsersQualified, dataUsersQualified])

  useEffect(() => {
    if (modal.modalId) {
      document.getElementById(`spanModal${modal.modalId}`).click()
    }
  }, [modal])

  useEffect(() => {
    if (closeModal) {
      modalRef.current.click()
      setModal({
        title: '',
        content: null,
        modalId: null,
        size: 'large',
      })
      setCloseModal(false)
    }
  }, [closeModal])
  useEffect(() => {
    if (modalAux.modalId) {
      document.getElementById(`spanModal${modalAux.modalId}`).click()
    }
  }, [modalAux])

  useEffect(() => {
    if (closeModalAux) {
      modalRefAux.current.click()
      setModalAux({
        title: '',
        content: null,
        modalId: null,
        size: 'large',
      })
      setCloseModalAux(false)
      const refetchData = async () => {
        try {
          if (refetchs.length > 0) {
            for (const refetch of refetchs) {
              await refetch()
            }
          }
        } catch (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }
      }

      refetchData()
    }
  }, [closeModalAux])

  const handleViewDetails = (row) => {
    setModal({
      title: `Buzón ciudadano de ${row.nombre}`,
      content: (
        <Ratings
          userId={row.id}
          handleViewDetailsAux={handleViewDetailsAux}
          handleEditAux={handleEditAux}
          setRefetchs={setRefetchs}
        />
      ),
      modalId: 'modal-rating-details',
      size: 'extra',
    })
  }

  const handleViewDetailsAux = (row) => {
    setModalAux({
      title: `Detalles de calificación`,
      content: (
        <DetailsRatings ratingId={row.id} setCloseModal={setCloseModalAux} />
      ),
      modalId: 'modal-rating-details-aux',
      size: 'extra',
    })
  }

  const handleEditAux = (row) => {
    setModalAux({
      title: `Editar calificación`,
      content: (
        <FormUsersRatings
          ratingId={row}
          setCloseModal={setCloseModalAux}
          refetchMain={refetch}
          refetchs={refetchs}
        />
      ),
      modalId: 'modal-rating-edit-aux',
      size: 'medium',
    })
  }

  return (
    <>
      <LayoutTable
        hideId
        hideAddNew
        data={dataTable}
        totalCount={totalCount}
        loadingData={loadingUsersQualified}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        actionBtnDetails={handleViewDetails}
        detailsText={<i className="fas fa-eye" />}
        title={'Buzón de area'}
        hideBtnDelete
        hideBtnEdit
      />

      <span
        id={`spanModal${modal.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modal.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={modalRef}
      />

      <ModalContent
        idModal={modal.modalId}
        title={modal.title}
        size={modal.size}
        onClose={() => {
          setModal({
            title: '',
            content: null,
            modalId: null,
            size: 'large',
          })
          setCloseModal(true)
        }}
        content={modal.content}
      />

      <span
        id={`spanModal${modalAux.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modalAux.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={modalRefAux}
      />

      <ModalContent
        idModal={modalAux.modalId}
        title={modalAux.title}
        size={modalAux.size}
        onClose={() => {
          setModalAux({
            title: '',
            content: null,
            modalId: null,
            size: 'large',
          })
          setCloseModalAux(true)
        }}
        content={modalAux.content}
      />
    </>
  )
}

export default RatingsCoordinator
